import { defineMessages } from "react-intl";

export const generalSettingsMessages = defineMessages({
  closedSidebar: {
    defaultMessage: "Closed Sidebar",
    id: "general-settings-messages.closed-sidebar",
  },
  chooseYourTheme: {
    defaultMessage: "Choose your theme",
    id: "general-settings-messages.choose-your-theme",
  },
});
